{
  "zh-TW": {
    "paintBooth": {
      "paints": "塗裝",
      "empty": "選擇一艘艦船以查看其塗裝。",
      "unavailable": "無法載入這艘艦船的塗裝全像影像。",
      "notFound": "找不到這艘艦船。"
    }
  }
}
